const featuredGamesConfig = [
  
    {
    title: "Location Tracker",
    gameClass: "LocationTracker",
    heroImage: "/thumbnails/LocationTracker.png",
    eyebrow: "Race ya!",
    desc: "Have Top-Gear style races with friends and track everyone's location in real-time.",
    accent: "from-emerald-500 via-lime-400 to-yellow-200",
  },
  {
    title: "Canasta",
    gameClass: "Canasta",
    heroImage: "/thumbnails/Canasta.png",
    eyebrow: "I remember that game!",
    desc: "A classic card game where players aim to form melds and canastas.",
    accent: "from-red-500 via-pink-400 to-rose-300",
  },
    {
    title: "Bingo",
    gameClass: "Bingo",
    heroImage: "/thumbnails/Bingo.png",
    eyebrow: "Eyes Down!",
    desc: "A fast-paced game of chance where players mark off numbers on their cards as they are called out, aiming for a winning pattern.",
    accent: "from-gray-700 via-rose-500 to-orange-300",
  },
  {
    title: "Red Light Green Light",
    gameClass: "RedLightGreenLight",
    heroImage: "/thumbnails/RedLightGreenLight.png",
    eyebrow: "So difficult!",
    desc: "A high-stakes dash to the finish line, where every move counts and the tension is palpable.",
    accent: "from-sky-500 via-cyan-400 to-teal-300",
  },
  {
    title: "Quiz",
    gameClass: "Quiz",
    heroImage: "/thumbnails/Quiz.png",
    eyebrow: "Party Staple",
    desc: "Rapid-fire trivia rounds with room-wide tension, fast reveals, and plenty of bragging rights.",
    accent: "from-amber-500 via-orange-400 to-yellow-300",
  },
  {
    title: "Time Tap",
    gameClass: "TimeTap",
    heroImage: "/thumbnails/TimeTap.png",
    eyebrow: "Crowd Favorite",
    desc: "A simple yet addictive reflex game where players must tap at the right time to score points.",
    accent: "from-fuchsia-500 via-rose-400 to-orange-300",
  },
  {
    title: "Hangman",
    gameClass: "Hangman",
    heroImage: "/thumbnails/Hangman.png",
    eyebrow: "Word Battle",
    desc: "Simple rules, instant tension, and a perfect fit for short rounds between bigger games.",
    accent: "from-emerald-500 via-lime-400 to-yellow-200",
  },
  {
    title: "Sinking Ships",
    gameClass: "SinkingShips",
    heroImage: "/thumbnails/SinkingShips.png",
    eyebrow: "Tactical Match",
    desc: "Call your shots, read your opponents, and sink fleets before they find yours.",
    accent: "from-indigo-600 via-blue-500 to-cyan-300",
  },
  { 
    title: "Unscramble",
    gameClass: "Unscramble",
    heroImage: "/thumbnails/unscramble.png",
    eyebrow: "Brain Teaser",
    desc: "Race against the clock to unscramble words, with points for speed and accuracy.",
    accent: "from-pink-500 via-purple-400 to-indigo-300",      
  }  ,
  { 
    title: "WheelOfDestiny",
    gameClass: "WheelOfDestiny",
    heroImage: "/thumbnails/WheelOfDestiny.png",
    eyebrow: "Try your Luck",
    desc: "Populate the options and then spin the wheel to see which wins",
    accent: "from-emerald-500 via-lime-400 to-yellow-200",
  },
  {
    title: "2048",
    gameClass: "2048",
    heroImage: "/thumbnails/2048.png",
    eyebrow: "Puzzle Classic",
    desc: "Slide numbered tiles to combine them and reach the 2048 tile.",
    accent: "from-yellow-500 via-orange-400 to-red-300",
  }
];

export default featuredGamesConfig;
